// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * NextWork API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ValidationStatus } from './validationStatus';
import {
    ValidationStatusFromJSON,
    ValidationStatusFromJSONTyped,
    ValidationStatusToJSON,
    ValidationStatusToJSONTyped,
} from './validationStatus';
import type { ValidationFileData } from './validationFileData';
import {
    ValidationFileDataFromJSON,
    ValidationFileDataFromJSONTyped,
    ValidationFileDataToJSON,
    ValidationFileDataToJSONTyped,
} from './validationFileData';
import type { ValidationType } from './validationType';
import {
    ValidationTypeFromJSON,
    ValidationTypeFromJSONTyped,
    ValidationTypeToJSON,
    ValidationTypeToJSONTyped,
} from './validationType';
import type { ValidationTextData } from './validationTextData';
import {
    ValidationTextDataFromJSON,
    ValidationTextDataFromJSONTyped,
    ValidationTextDataToJSON,
    ValidationTextDataToJSONTyped,
} from './validationTextData';

/**
 * Validation object with data and status
 * @export
 * @interface ValidationResponse
 */
export interface ValidationResponse {
    /**
     * 
     * @type {string}
     * @memberof ValidationResponse
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof ValidationResponse
     */
    hidden?: boolean;
    /**
     * 
     * @type {ValidationType}
     * @memberof ValidationResponse
     */
    type: ValidationType;
    /**
     * 
     * @type {ValidationTextData}
     * @memberof ValidationResponse
     */
    text?: ValidationTextData;
    /**
     * 
     * @type {ValidationFileData}
     * @memberof ValidationResponse
     */
    file?: ValidationFileData;
    /**
     * 
     * @type {ValidationStatus}
     * @memberof ValidationResponse
     */
    status: ValidationStatus;
}



/**
 * Check if a given object implements the ValidationResponse interface.
 */
export function instanceOfValidationResponse(value: object): value is ValidationResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function ValidationResponseFromJSON(json: any): ValidationResponse {
    return ValidationResponseFromJSONTyped(json, false);
}

export function ValidationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'hidden': json['hidden'] == null ? undefined : json['hidden'],
        'type': ValidationTypeFromJSON(json['type']),
        'text': json['text'] == null ? undefined : ValidationTextDataFromJSON(json['text']),
        'file': json['file'] == null ? undefined : ValidationFileDataFromJSON(json['file']),
        'status': ValidationStatusFromJSON(json['status']),
    };
}

export function ValidationResponseToJSON(json: any): ValidationResponse {
    return ValidationResponseToJSONTyped(json, false);
}

export function ValidationResponseToJSONTyped(value?: ValidationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'hidden': value['hidden'],
        'type': ValidationTypeToJSON(value['type']),
        'text': ValidationTextDataToJSON(value['text']),
        'file': ValidationFileDataToJSON(value['file']),
        'status': ValidationStatusToJSON(value['status']),
    };
}

